import Document from '@/models/Document';

const GET_DOCUMENTS = 'get_documents';
const GET_DOCUMENTS_REQUEST = 'get_documents_request';
const GET_DOCUMENTS_SUCCESS = 'get_documents_success';
const GET_DOCUMENTS_ERROR = 'get_documents_error';

export { GET_DOCUMENTS };

export default {
    state: {
        documents: [],
        loading: false,
        documentsErrors: [],
        documentsMeta: {},
        trajectory_file_type: '',
    },
    mutations: {
        [GET_DOCUMENTS_REQUEST]: (state) => {
            state.documents = [];
            state.loading = true;
            state.documentsErrors = [];
            state.documentsMeta = {};
        },
        [GET_DOCUMENTS_SUCCESS]: (state, { documents, meta }) => {
            state.documents = documents;
            state.loading = false;
            state.documentsErrors = [];
            state.documentsMeta = meta;
        },
        [GET_DOCUMENTS_ERROR]: (state, { errors }) => {
            state.documents = [];
            state.loading = false;
            state.documentsErrors = errors;
            state.documentsMeta = {};
        },
    },
    actions: {
        [GET_DOCUMENTS]: ({ commit, state, rootState }, { trajectoryId, params = {} }) => {
            if (!trajectoryId) {
                trajectoryId = rootState.trajectory.trajectory.id;
            }
            commit(GET_DOCUMENTS_REQUEST);
            return new Promise((resolve, reject) => {
                // If no page specified at dispatch
                if (!params.page) {
                    // Use the current one if present, the first one othewise
                    if (state.documentsMeta.current_page) {
                        params.page = state.documentsMeta.current_page;
                    } else {
                        params.page = 1;
                    }
                }

                // If no filter is explicitly specified then used the previous one
                if (!params.trajectory_file_type && state.trajectory_file_type) {
                    params.trajectory_file_type = state.trajectory_file_type;
                }

                const TrajectoryDocuments = Document.makeModel(`/trajectories/${trajectoryId}/files`);
                TrajectoryDocuments.collection(params)
                    .then(({ items, meta }) => {
                        const documents = items;
                        commit(GET_DOCUMENTS_SUCCESS, { documents, meta });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_DOCUMENTS_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/documents.js